// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3Jfj7","alert":"SettungsInbox_alert__3eiXd"};